<template>
    <div class="row">
        <div class="col-md-12">
            <div class="progress application-progress">
                <template v-for="track_step in statuses">
                <div v-if="train_tracks[track_step].is_complete" class="progress-bar progress-bar-success" :style="`width:${trackWidth}%`">
                    <span class="progress-text addTooltip" :data-tooltip-text="lang('summary_process_complete')">{{lang(track_step)}}</span>
                </div>

                <div v-else-if="train_tracks[track_step].is_active" class="progress-bar progress-bar-transparent" :style="`width:${trackWidth}%; position: relative;`">
                    <span class="progress-bar progress-bar-success progress-bar-striped active" :style="`width: ${train_tracks[track_step].progress}%`"></span>
                    <span class="progress-text active-progress addTooltip" :data-tooltip-text="lang('maintenance_printable_status')">{{lang(track_step)}}</span>
                </div>
                <div v-else class="progress-bar progress-bar-transparent" :style="`width:${trackWidth}%`">
                    <span class="progress-text addTooltip" :data-tooltip-text="lang('summary_process_pending')">{{lang(track_step)}}</span>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "np-train-tracks",
        props: {
            train_tracks: {},
        },
        data: function(){
            return {
                statuses: []
                }
        },
        created: function(){
            // this.data = this.train_tracks;
            this.statuses = Object.keys(this.train_tracks);
        },
        methods: {
        },
        computed: {
            trackWidth: function (){
                return Math.floor(100 / this.statuses.length);
            }
        },
        watch: {

        }
    }
</script>

<style scoped>

</style>